<div [innerHTML]="cellInnerHTML"></div>
